export const Constants = {
    InternalActivationOrderId: "SToneFakeActivationOrderId-443d73f8-0a31-46e5-8436-7b340a0d16ac"
}